import { computed } from 'vue'
import { defineStore } from 'pinia'
import { DataRow, Table } from '../types/components/data-rendering'
import { useStoreProfiles } from './useStoreProfiles'
import { storeToRefs } from 'pinia'
import { subsetMetaByKeys } from './helpers/useTransformStore'
import { useTaskProfiles } from './useTaskProfiles'
import { setGroupSort } from './helpers/useSetDefaultConditions'

export const useMerchPlanner = defineStore('merchPlanner', () => {
  const { taskTable, taskData } = storeToRefs(useTaskProfiles())
  const getMerchPlannerData = computed(() => {
    const merchPlannerKeys = [
      'store_id',
      'orderline_id',
      'task_start_date',
      'task_end_date',
      'supplies_sent_to',
      'task_type',
      'attachment',
      'recap',
      'task_status',
      'store_type',
      'est_task_duration',
      'cycle_id',
      'store_number',
      'recap',
      'order_type_id',
      'job_name',
    ]

    const merchPlannerData: Table = {
      meta: subsetMetaByKeys(taskTable.value.meta, merchPlannerKeys, {
        renameKeys: [
          {
            from: 'task_start_date',
            to: {
              label: { en_US: 'Program Start', es_MX: '', fr_CA: 'Lancement du programme' },
              type: 'date',
            },
          },
          {
            from: 'task_end_date',
            to: {
              label: { en_US: 'Program End', es_MX: '', fr_CA: 'Fin du programme' },
              type: 'date',
            },
          },
          {
            from: 'task_status',
            to: { label: { en_US: 'Program Status', es_MX: '', fr_CA: 'Statut' }, type: 'string' },
          },
          {
            from: 'recap',
            to: {
              label: { en_US: 'Recap (Preview)', es_MX: '', fr_CA: 'Aperçu du récapitulatif' },
              type: 'string',
            },
          },
          {
            from: 'order_type_id',
            to: {
              label: { en_US: '', es_MX: '', fr_CA: '' },
              type: 'string',
              hide: true,
            },
          },
        ],
      }),
      data: taskData.value,
    }
    const transformed = transformToMerchPlanner(merchPlannerData)

    const returnTable = setGroupSort(transformed as Table, {
      sortBy: 'task_start_date',
    })

    return returnTable
  })
  const transformToMerchPlanner = (data: { meta: { [key: string]: any }; data: DataRow[] }) => {
    const newData: any[] = []
    const { getAllStoreData } = storeToRefs(useStoreProfiles())
    const storeIdHash: { [key: string]: any } = {}
    for (let index = 0; index < getAllStoreData.value.length; index++) {
      storeIdHash[getAllStoreData.value[index].store_id] = true
    }
    for (let index = 0; index < data.data.length; index++) {
      //filter out non merch type

      const newOrderlines = newData.map((item) => item.orderline_id)
      const currentTask = data.data[index]

      if (currentTask.order_type_id != 4) continue

      if (newOrderlines.indexOf(currentTask.orderline_id) > -1) {
        //increment attachment count if attachment
        if (currentTask.attachment && (currentTask.attachment as string).length > 0) {
          newData[newOrderlines.indexOf(currentTask.orderline_id)].attachments++
        }
        //add store count
        if (storeIdHash[currentTask.store_id]) {
        }
        newData[newOrderlines.indexOf(currentTask.orderline_id)].store_count =
          newData[newOrderlines.indexOf(currentTask.orderline_id)].store_count + 1
      } else {
        //create new orderline record

        //remove unneeded attachment col from row
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { store_number, attachment, ...rest } = currentTask
        newData.push({
          _index: newData.length,
          orderline_id: rest.orderline_id,
          task_start_date: rest.task_start_date,
          task_end_date: rest.task_end_date,
          supplies_sent_to: rest.supplies_sent_to,
          store_count: 1,
          task_status: rest.task_status,
          attachments: 0, //assume zero unless there is an attachment
          recap: rest.recap,
          est_task_duration: rest.est_task_duration,
          store_type:
            storeIdHash[currentTask.store_id].store_type == 'Non-network'
              ? 'Non-network'
              : 'Network',
          task_type: rest.task_type,
          cycle_id: rest.cycle_id,
          job_name: rest.job_name,
          // week: 1, //TODO PLACEHOLDER
        })
        if (currentTask.attachment && (currentTask.attachment as string).length > 0) {
          newData[newData.length - 1].attachments++
        }
      }
    }
    //remove now unneded attachment col
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { store_number, attachment, ...cols } = data.meta.columns

    return {
      meta: {
        columns: {
          orderline_id: cols.orderline_id,
          job_name: cols.job_name,
          task_start_date: cols.task_start_date,
          task_end_date: cols.task_end_date,
          supplies_sent_to: cols.supplies_sent_to,
          store_count: {
            label: { en_US: 'Store Count', fr_CA: 'Nombre de magasins', es_MX: '' },
            type: 'number',
          },
          task_status: cols.task_status,
          attachments: {
            label: { en_US: 'Attachments', fr_CA: 'Pièces jointes', es_MX: '' },
            type: 'number',
          },
          recap: cols.recap,
          est_task_duration: cols.est_task_duration,
          store_type: {
            label: { en_US: 'Store Type', fr_CA: 'Type de magasins', es_MX: '' },
            type: 'string',
          },
          task_type: cols.task_type,
          cycle_id: cols.cycle_id,
          // week: {
          //   label: { en_US: 'Week', fr_CA: 'Semaine', es_MX: '' },
          //   type: 'number',
          // },
        },
      },
      data: newData as unknown as DataRow[],
    }
  }

  return {
    getMerchPlannerData,
  }
})
